import { createContext } from 'react';

/** Jednorazowy `nonce` CSP z wejścia SSR — dla skryptów dokumentu; w przeglądarce pusty (niepotrzebny). */
export const NonceContext = createContext<string | undefined>(undefined);
